<script lang="ts">
  import type { NavPoints } from './navigation.types';
  import NavPoint from './NavPoint.svelte';

  const { points }: { points: NavPoints } = $props();
</script>

{#each Object.entries(points) as [id, point] (id)}
  <NavPoint icon={point.icon} href={point.href} active={point.active} alarm={point.alarm} count={point.count} points={point.sub}>
    {point.label}
  </NavPoint>
{/each}
